/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createRound } from '../../factoriesNumber.js';
export var roundDependencies = {
  typedDependencies,
  createRound
};